import { Component, Input, OnInit } from '@angular/core';
import { MemberCard, MemberCardQuery, MemberDetails, MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  @Input() title: string;
  @Input() isHomePage: boolean = false;
  memberDetails$: Observable<MemberDetails | undefined>;
  memberCard$: Observable<MemberCard | undefined>;
  constructor(
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery
  ) {}

  ngOnInit(): void {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
  }
}
